import React from "react";
import ForecastRouter from './Forecast/Router';
export { getFields } from './Forecast/Router';

export default function CarbonForecastRouter(props) {
    return (
        <ForecastRouter {...props} mode='CARBON' />
    );
};
